import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormGroup, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicDialogService } from 'src/app/dynamic-dialog/dynamic-dialog.service';
import { Actions } from 'src/app/models/actions';
import { Schedule } from 'src/app/models/schedule';
import { ToastGlobalService } from 'src/app/layout/toast-global/toast-global.service';
import { ScheduleService } from '../schedule/schedule.service';
import { TenantState } from 'src/app/store/state/tenant.state';
import { Select } from '@ngxs/store';
import { combineLatest, Observable, Subject, Subscription } from 'rxjs';
import { Criteria } from 'src/app/models/criteria';
import { Part } from 'src/app/models/part';
import { TableFilter } from 'src/app/models/tableFilter';
import { PagedResponse } from 'src/app/models/pagedResponse';
import { PartService } from '../part/service/part.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScheduleGroup } from 'src/app/models/scheduleGroup';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { MaintainSchedule } from 'src/app/models/constant/right';
import { PartVehicle } from 'src/app/models/partVehicle';
import { MatChipInputEvent } from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { takeUntil } from 'rxjs/operators';
import { TenantStateService } from 'src/app/shared/services/tenant.state.service';
import { GenericValidators } from 'src/app/shared/generic-validators';
import { ScheduleCriteriaPipe } from 'src/app/shared/pipes/scheduleCriteria';
import { DrawerService } from 'src/app/shared/drawer/drawer.service';
import { ScheduleCriteriaFormComponent } from './schedule-criteria-form/schedule-criteria-form.component';
import { cloneDeep } from 'lodash';
import { ScheduleVehiclesFormComponent } from './schedule-vehicles-form/schedule-vehicles-form.component';
import { EnumToArrayPipe } from 'src/app/shared/pipes/enumToArray';
import { updateTabIndexRoute } from '../../shared/handler/common-functions.util';
import { ReferenceDataService } from 'src/app/shared/services/reference-data.service';
import { ReferenceData } from 'src/app/models/referenceData';
import { SpaRoutingService } from 'src/app/shared/services/spa.routing.service';

@Component({
    selector: 'app-schedule-detail',
    templateUrl: './schedule-detail.component.html',
    styleUrls: ['./schedule-detail.component.css'],
    standalone: false
})
export class ScheduleDetailComponent implements OnInit, OnDestroy {
  @Select(TenantState.getCurrentTenantExternalId) getCurrentTenantExternalId: Observable<string>;
  schedule: Schedule;
  scheduleForm: UntypedFormGroup;
  Actions: typeof Actions = Actions;

  selectedIndex = 0;
  tenantId: string;
  subscription: Subscription;

  innerWidth: number;
  direction = 'horizontal';
  partsData: PagedResponse;
  lastFilter = new TableFilter();
  availLoading = true;
  loading: boolean = false;
  editable = false;
  canEdit = false;
  allSelected: any;
  cfrSections: string[] = [];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  addOnBlur = true;

  addGroup = false;
  newGroupButtonLabel = 'Add Group';
  newGroup: ScheduleGroup;
  manufacturer = new UntypedFormControl();
  model = new UntypedFormControl();
  other = new UntypedFormControl();
  startYear = new UntypedFormControl();
  endYear = new UntypedFormControl();

  criteriaRowDefinitions: any;
  criteriaListData: any;

  supportedVehiclesRowDefinitions: any;
  supportedVehiclesListData: Array<any> = [];

  menuOptions: any;
  destroy$: Subject<any> = new Subject();
  sensorTypes: ReferenceData[] = [];

  constructor(
    private authorService: AuthService,
    private authorizationService: AuthorizationService,
    private route: ActivatedRoute,
    private router: Router,
    private toastGlobalService: ToastGlobalService,
    private formBuilder: UntypedFormBuilder,
    private scheduleService: ScheduleService,
    private dialogService: DynamicDialogService,
    private partService: PartService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private validators: GenericValidators,
    private scheduleCriteriaPipe: ScheduleCriteriaPipe,
    private drawerService: DrawerService,
    private referenceDataService: ReferenceDataService,
    private spaRoutingService: SpaRoutingService) { }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = window.innerWidth;
    this.direction = this.innerWidth >= 400 ? 'horizontal' : 'vertical';
  }

  ngOnInit(): void {
    this.referenceDataService.getSensorTypes().subscribe((st: ReferenceData[]) => {
      this.sensorTypes = st.filter(st => st.name.includes("Schedule"));
    });
    this.menuOptions = [
      {
        icon: 'fa fa-plus',
        text: '@add',
        action: 'add',
        validator: (rows) => this.validators.notSelectedValidator(rows)
      },
      {
        icon: 'fa fa-pencil',
        text: '@edit',
        action: 'edit',
        validator: (rows) => this.validators.selectedLengthValidator(rows, '=', 1)
      },
      {
        icon: 'fa fa-clone',
        text: '@duplicate',
        action: 'duplicate',
        validator: (rows) => this.validators.selectedLengthValidator(rows, '=', 1)
      },
      {
        icon: 'fa fa-trash',
        text: '@delete',
        action: 'delete',
        validator: (rows) => this.validators.selectedLengthValidator(rows, '=', 1)
      }      
    ];
    this.criteriaRowDefinitions = [
      {
        propertyName: "attributes",
        header: "@attributes",
        widthPriority: 1
      },
      {
        propertyName: "criteria",
        header: "@interval",
        widthPriority: 1
      }
    ];
    this.supportedVehiclesRowDefinitions = [
      {
        propertyName: "manufacturer",
        header: "@manufacturer",
        widthPriority: 1
      },
      {
        propertyName: "model",
        header: "@model",
        widthPriority: 1
      },
      {
        propertyName: "type",
        header: "@type",
        widthPriority: 1
      },
      {
        propertyName: "startYear",
        header: "@startYear",
        widthPriority: 1
      },
      {
        propertyName: "endYear",
        header: "@endYear",
        widthPriority: 1
      }
    ];
    const action = this.schedule?.action ?? this.Actions[0];
    this.scheduleForm = this.formBuilder.group({
      name: [{ value: this.schedule?.name ?? '', disabled: !this.editable }, Validators.required],
      description: [{ value: this.schedule?.description ?? '', disabled: !this.editable }, Validators.nullValidator],
      action: [{ value: action, disabled: !this.editable }, Validators.required],
      category: [{ value: this.schedule?.category ?? '', disabled: !this.editable }, Validators.required],
      isActive: [{ value: this.schedule?.isActive, disabled: !this.editable }, Validators.nullValidator],
      hours: [{ value: this.schedule?.hours ?? '', disabled: !this.editable }, Validators.nullValidator],
      sensorType: [{ value: this.schedule?.sensorTypeId ?? 0, disabled: !this.editable }, Validators.nullValidator],
      cfrSection: [{ value: this.schedule?.cfrSections ?? '', disabled: !this.editable}, Validators.nullValidator]
    });
    this.canEdit = this.authorizationService.hasRight(
      this.authorService.user.profile,
      MaintainSchedule
    );
    combineLatest([this.getCurrentTenantExternalId, this.route.paramMap])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([externalId, params]) => {
        if (!externalId) return;
        this.tenantId = externalId;
        const id = params.get('id');

        // selected from table
        if (this.scheduleService.selectedSchedule && id === this.scheduleService.selectedSchedule.id) {
          this.schedule = this.scheduleService.selectedSchedule;
          this.editable = false;
          this.reactiveForm();
          this.setDataSource();
        }
        // coming in from URL
        else if (id) {
          this.loading = true;
          this.scheduleService.getScheduleById(id).subscribe(res => {
            this.schedule = res;
            this.editable = false;
            this.reactiveForm();
            this.setDataSource();
            this.loading = false;
          });
        }
        // coming in from plus button on filter list
        else {
          this.schedule = new Schedule();
          this.editable = true;
          this.reactiveForm();
          this.setDataSource();
        }
      });
    this.allSelected = false;
  }
  private setDataSource(): void {
    if(this.schedule){
      this.criteriaListData = this.schedule.criteria.map((x, index) => {
        const attributes = Object.keys(x.schedulingAttributes).map(y => {
          return `${y}/${x.schedulingAttributes[y]}`
        });
        if(attributes.length < 1){
          attributes.push('Default');
        }
        return { 
          attributes: attributes,
          criteria: this.scheduleCriteriaPipe.transform(x),
          index: index
        };
      });
      this.supportedVehiclesListData = this.schedule.groups;
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
  
  updateSchedule(): void {
    if (this.scheduleForm.invalid) {
      this.scheduleForm.markAllAsTouched();
      const notification = this.translate.instant('@missingValues');
      const action = this.translate.instant('@gotItNow');
      this.snackBar.open(notification, action, { duration: 8555 });
      return;
    }
    const sensorTypeControl = this.scheduleForm.get('sensorType')?.value;
    this.schedule.name = this.scheduleForm.get('name').value.trim();
    this.schedule.category = this.scheduleForm.get('category').value.trim();
    this.schedule.description = this.scheduleForm.get('description').value.trim();
    this.schedule.hours = this.scheduleForm.get('hours').value;
    this.schedule.sensorTypeId = sensorTypeControl?.id || this.schedule.sensorTypeId;
    this.schedule.sensorType = sensorTypeControl?.name || this.schedule.sensorType;
    this.schedule.action = this.scheduleForm.get('action').value;
    this.schedule.isActive = this.schedule.isActive;
    this.schedule.cfrSections = this.cfrSections;
    
    if (this.schedule.id) {
      this.saveSchedule();
      this.updateIsEditing();
    }
    else {
      this.scheduleService.postSchedule(this.schedule).subscribe(res => {
        const toast = this.translate.instant('@addSuccessful');
        this.toastGlobalService.show(toast, { classname: 'success' });
        this.schedule = res;
        this.toggle();
      });
    }
  }

  toggle(): void {
    if (this.scheduleService.selectedFleetSchedule && this.scheduleService.selectedFleetSchedule.id) {
      this.spaRoutingService.navigateToFleetSchedule(this.scheduleService.selectedFleetSchedule.id);
    }
  }

  public ontoggle(event: MatSlideToggleChange): void {
    this.schedule.isActive = event.checked;
  }

  updateIsEditing(): void {
    this.editable = !this.editable;
    this.reactiveForm();
  }

  reactiveForm(): void {
    let action = this.schedule.action ?? this.Actions[0];
    this.scheduleForm = this.formBuilder.group({
      name: [{ value: this.schedule.name ?? '', disabled: !this.editable }, Validators.required],
      description: [{ value: this.schedule.description ?? '', disabled: !this.editable }, Validators.nullValidator],
      action: [{ value: action, disabled: !this.editable }, Validators.required],
      category: [{ value: this.schedule.category ?? '', disabled: !this.editable }, Validators.required],
      isActive: [{ value: this.schedule.isActive, disabled: !this.editable }, Validators.nullValidator],
      hours: [{ value: this.schedule.hours ?? '', disabled: !this.editable }, Validators.nullValidator],
      sensorType: [{ value: this.schedule.sensorTypeId ?? 0, disabled: !this.editable }, Validators.nullValidator],
      cfrSection: [{ value: this.schedule?.cfrSections ?? '', disabled: !this.editable}, Validators.nullValidator]
    });
    this.cfrSections = this.schedule.cfrSections ?? [];
    this.scheduleForm.controls['action'].setValue(action);
  }  

  removeParts(event: any): void {
    if (event.parts) {
      this.schedule.parts = event.parts;
    }
    this.saveSchedule();
  }

  addPart(currentPart: Part): void {
    const payload = {
      part: currentPart,
      layout: null,
      showMassAdd: false
    };
    this.dialogService.openAddPartDialog(payload).afterClosed().subscribe(res => {
      if (res) {
        currentPart.location = res.location;
        currentPart.vehicles = new Array<PartVehicle>();
        const newPartVehicle = new PartVehicle();
        newPartVehicle.partQuantity = res.quantity;
        currentPart.vehicles.push(newPartVehicle);
        this.schedule.parts.push(currentPart);
        this.saveSchedule();
      }
    });
  }

  updateData(passedFilter: TableFilter): void {
    if (this.schedule && this.schedule.id) {
      this.availLoading = true;
      this.partService.getScheduleData(
        this.schedule.id,
        passedFilter.filter,
        passedFilter.sort,
        passedFilter.offset,
        passedFilter.limit)
        .subscribe(res => {
          this.partsData = res.partResponse;
          this.lastFilter = passedFilter;
          this.availLoading = false;
        });
    }
  }

  add(event: MatChipInputEvent): void {
    let index = this.cfrSections.indexOf(event.value.trim());
    if (index < 0 && event.value.trim()) {
      this.cfrSections.push(event.value.trim());
    }
    event.chipInput!.clear();
  }

  remove(code: string): void {
    let index = this.cfrSections.indexOf(code);
    if (index > -1) {
      this.cfrSections.splice(index, 1);
    }
  }

  private saveSchedule(): void {
    this.scheduleService.updateSchedule(this.schedule).subscribe(updatedSchedule => {
      if(updatedSchedule){
        const toast = this.translate.instant('@updateSuccessful');
        this.toastGlobalService.show(toast, { classname: 'success' });
        this.schedule = updatedSchedule;
        this.reactiveForm();
      }
    });

  }

  onTabClick(event) {
    updateTabIndexRoute(event.index, this.router, this.route);
  }

  onSupportedVehiclesAction(actionEvent: any): void {
    switch (actionEvent.action) {
      case 'delete':
        if (actionEvent.selectedData && actionEvent.selectedData.length === 1) {
          if (actionEvent.selectedData && actionEvent.selectedData.length === 1) {    
            this.schedule.groups = this.schedule.groups.filter(x => {
              return x !== actionEvent.selectedData[0];
            });
            this.setDataSource();
          }
          break;
        }
        break;
      case 'edit':
        if (actionEvent.selectedData && actionEvent.selectedData.length === 1) {
          const editVehicle = actionEvent.selectedData[0];
          const formComponent = this.drawerService.open(
            ScheduleVehiclesFormComponent,
            [
              { input: "existingScheduleVehicle", value: editVehicle }
            ],
            {
              resizable: true,
            });
          formComponent.saved
            .pipe(
              takeUntil(this.destroy$)
            ).subscribe((vehicle) => {
              if (vehicle) {
                let foundIndex = this.schedule.groups.findIndex(x => x === actionEvent.selectedData[0]);
                this.schedule.groups[foundIndex] = vehicle;
                this.setDataSource();
              }
              this.drawerService.close();
            });
        }
        break;
      case 'duplicate':
        if (actionEvent.selectedData && actionEvent.selectedData.length === 1) {
          const duplicate = cloneDeep(actionEvent.selectedData[0]);
          const formComponent = this.drawerService.open(
            ScheduleVehiclesFormComponent,
            [
              { input: "existingScheduleVehicle", value: duplicate }
            ],
            {
              resizable: true,
            });
          formComponent.saved
            .pipe(
              takeUntil(this.destroy$)
            ).subscribe((vehicle) => {
              if (vehicle) {
                this.schedule.groups.push(vehicle);
                this.setDataSource();
              }
              this.drawerService.close();
            });
        }
        break;
      case 'add':
        const formComponent = this.drawerService.open(
          ScheduleVehiclesFormComponent,
          [],
          {
            resizable: true,
          }
        );
        formComponent.saved
          .pipe(
            takeUntil(this.destroy$)
          ).subscribe((vehicle) => {
            if (vehicle) {
              this.schedule.groups.push(vehicle);
              this.setDataSource();
            }
            this.drawerService.close();
          });
        break;
    }
  }
  
  onCriteriaAction(actionEvent: any): void {
    switch (actionEvent.action) {
      case 'delete':
        if (actionEvent.selectedData && actionEvent.selectedData.length === 1) {    
          this.schedule.criteria.splice(actionEvent.selectedData[0].index, 1);
          this.setDataSource();
        }
        break;
      case 'edit':
        if (actionEvent.selectedData && actionEvent.selectedData.length === 1) {
          const rowIndex = actionEvent.selectedData[0].index;
          const editCriteria = this.schedule.criteria[rowIndex];
          const formComponent = this.drawerService.open(
            ScheduleCriteriaFormComponent,
            [
              { input: "existingScheduleCriteria", value: editCriteria }
            ],
            {
              resizable: true,
            });
          formComponent.saved
            .pipe(
              takeUntil(this.destroy$)
            ).subscribe((criteria) => {
              if (criteria) {
                this.updateCriteria(criteria, rowIndex);
              }
              this.drawerService.close();
            });
        }
        break;
      case 'duplicate':
        if (actionEvent.selectedData && actionEvent.selectedData.length === 1) {
          const duplicate = cloneDeep(this.schedule.criteria[actionEvent.selectedData[0].index]);
          const formComponent = this.drawerService.open(
            ScheduleCriteriaFormComponent,
            [
              { input: "existingScheduleCriteria", value: duplicate }
            ],
            {
              resizable: true,
            });
          formComponent.saved
            .pipe(
              takeUntil(this.destroy$)
            ).subscribe((criteria) => {
              if (criteria) {
                this.addCriteria(criteria);
              }
              this.drawerService.close();
            });
        }
        break;
      case 'add':
        const criteriaFormComponent = this.drawerService.open(
          ScheduleCriteriaFormComponent,
          [],
          {
            resizable: true,
          }
        );
        criteriaFormComponent.saved
          .pipe(
            takeUntil(this.destroy$)
          ).subscribe((criteria) => {
            if (criteria) {
              this.addCriteria(criteria);
            }
            this.drawerService.close();
          });
        break;
    }
  }
  private addCriteria(criteria: any): void {
    this.schedule.criteria.push(criteria);   
    this.setDataSource(); 
  }
  private updateCriteria(criteria: any, rowIndex: number): void {
    if (criteria) {
      this.schedule.criteria.splice(rowIndex, 1, criteria);
      this.setDataSource();
    }
  }
  
}
